<highcharts-chart
  [Highcharts]="highcharts"
  [options]="solidGaugeChartOptions"
  style="width: 100%; height: 90%; display: block"
>
</highcharts-chart>
